const blogTextAndImage = {
  displayField: 'title',
  name: 'Blog - Text And Image',
  description: 'Inline component within Articles for adding content blocks with an Image',
  fields: [
    {
      id: 'title',
      name: 'Title',
      type: 'Symbol',
      localized: false,
      required: false,
      validations: [],
      disabled: false,
      omitted: false
    },
    {
      id: 'header',
      name: 'Header',
      type: 'Symbol',
      localized: true,
      required: false,
      validations: [],
      disabled: false,
      omitted: false
    },
    {
      id: 'dropCap',
      name: 'Include Dropcap',
      type: 'Boolean',
      localized: false,
      required: false,
      validations: [],
      disabled: true,
      omitted: false
    },
    {
      id: 'richText',
      name: 'Rich Text',
      type: 'RichText',
      localized: true,
      required: false,
      validations: [
        {
          enabledMarks: [ 'bold', 'italic', 'underline', 'subscript', 'superscript' ],
          message: 'Only bold, italic, underline, subscript, and superscript marks are allowed'
        },
        {
          enabledNodeTypes: [
            'heading-4',
            'ordered-list',
            'unordered-list',
            'hyperlink',
            'entry-hyperlink',
            'asset-hyperlink',
            'hr',
            'blockquote'
          ],
          message: 'Only heading 4, ordered list, unordered list, link to Url, link to entry, link to asset, horizontal rule, and quote nodes are allowed'
        },
        { nodes: {} }
      ],
      disabled: false,
      omitted: false
    },
    {
      id: 'reverse',
      name: 'Image Placement',
      type: 'Boolean',
      localized: false,
      required: false,
      validations: [],
      defaultValue: { 'en-US': false },
      disabled: false,
      omitted: false
    },
    {
      id: 'img',
      name: 'Image',
      type: 'Link',
      localized: false,
      required: false,
      validations: [],
      disabled: true,
      omitted: true,
      linkType: 'Asset'
    },
    {
      id: 'imgFocalPoint',
      name: 'Image with Focal Point',
      type: 'Link',
      localized: false,
      required: false,
      validations: [ { linkContentType: [ 'imageWithFocalPoint' ] } ],
      disabled: false,
      omitted: false,
      linkType: 'Entry'
    }
  ],
  sys: {
    id: 'blogTextAndImage',
    version: 9,
    updatedAt: '2023-08-02T21:38:46.768Z'
  }
};
export default blogTextAndImage;